export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-18.db6e10e9.jpg";